import { ChakraProvider, localStorageManager } from '@chakra-ui/react';
import '@fontsource/roboto';
import '@fontsource/roboto-condensed';
import loadable from '@loadable/component';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/400.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './css/general.css';
import './css/golftec-font.css';
import * as serviceWorker from './serviceWorker';
import { persistor, store } from './utils/store';
import extendedTheme from './utils/theme';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import pkg from '../package.json';
import returnEnvDataDog from './components/CommonFunction/envDataDog';

const LanguageProvider = loadable(
  () => import('./components/LanguageProvider')
);
const App = loadable(() => import('./App'));

const envDataDog = returnEnvDataDog();

const appId = process.env.REACT_APP_ID_DATADOG_GT;
const clientToken = process.env.REACT_APP_CLIENT_TOKEN_DATADOG_GT;
const site = process.env.REACT_APP_SITE_DATADOG;

if (!window.location.hostname.match(/localhost/)) {
  if (!appId || !clientToken || !site) {
    console.warn('Datadog config missing', {
      appId,
      clientToken,
      site,
    });
  } else {
    datadogRum.init({
      applicationId: appId,
      clientToken,
      site,
      service: 'golftec-clubhouse',
      env: envDataDog,
      version: pkg?.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackResources: true,
      trackUserInteractions: true,
      trackLongTasks: true,
      plugins: [reactPlugin({ router: true })],
    });
  }
}

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
]);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js') // Đường dẫn tới service worker file bạn đã tạo ở bước trước
      .then((registration) => {
        console.log('Service Worker registered:', registration);
      })
      .catch((error) => {
        console.error('Error registering Service Worker:', error);
      });
  });
}
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ChakraProvider
          theme={extendedTheme}
          colorModeManager={localStorageManager}
        >
          <LanguageProvider>
            <RouterProvider
              router={router}
              future={{
                v7_startTransition: true,
              }}
            />
          </LanguageProvider>
        </ChakraProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
